import { makeAutoObservable } from 'mobx'
import { Status } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { type IShortLinkUrlEditor } from 'entities/ShortLink/api/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { type MergeField } from 'entities/MergeField/model/MergeField'
import { mergeFieldReplacer } from 'entities/Message/lib/mergeFieldReplacer'
import { EnumVariantMessageField, MessageField, MessageFieldStore } from 'widgets/MessageField'
import { MergeFieldsIconAction } from 'widgets/MergeField/ui/actions/MergeFieldsIconAction/MergeFieldsIconAction'
import styles from './styles.module.scss'

export class ShortLinkUrlEditor implements IShortLinkUrlEditor {
  private _field: MessageFieldStore

  constructor(private _entities: IEntitiesStore) {
    this._field = new MessageFieldStore(
      {
        placeholder: 'Enter your URL',
        styles: {
          minHeight: 28,
          whiteSpace: 'nowrap',
          overflowX: 'auto',
          overflowY: 'hidden',
        },
        noCounter: true,
        disableLinks: true,
        skipShortLinkSync: true,
        variant: EnumVariantMessageField.Clean,
        resetOnUnmount: false,
      },
      this._entities
    )

    void this._entities.mergeFieldStore.loadAllFields()

    makeAutoObservable(this)
  }

  get text() {
    return this._field.text
  }

  get messageFieldStore() {
    return this._field
  }

  setText = (value: string) => {
    this._field.setMessageData({
      message: value,
      attachments: [],
      isReset: false,
      isReplace: true,
      isFocus: true,
    })
  }

  private _insertMergeField = (field: MergeField) => {
    this._field.addContent?.(mergeFieldReplacer(this._entities, field.template))
  }

  renderField = () => (
    <div className={styles.field}>
      <MessageField messageFieldStore={this._field} />
    </div>
  )

  renderMergeFieldAction = () => (
    <div className={styles.mergeFieldAction}>
      <MergeFieldsIconAction
        onAddMergeField={this._insertMergeField}
        isAllConnectedOrDisconnectedIntegration
        zIndex={ZIndex.OVERLAY_MIDDLE_100}
      />
      <Status title={'Beta'} intent={'warning'} emphasis={'high'} size={'label'} />
    </div>
  )

  dispose = () => {
    this._field.reset()
  }
}
